<template>
    <div class="main-layout">
        <template v-if="$Auth.isLoggedIn()">
            <MainHeader />
            <MainMobileHeader />
        </template>

        <div v-else class="main-layout__container">
            <AuthHeader />
        </div>

        <main class="main-layout__content">
            <Error403 v-if="$PageProperties.accessDenied" />
            <Error404 v-if="$PageProperties.notFound" />
            <router-view v-if="!$PageProperties.accessDenied && !$PageProperties.notFound" />
        </main>

        <MainFooter />
    </div>
</template>

<script lang="ts" setup>
    import { injectStrict } from '@/injection/injectStrict.ts';
    import { AuthKey, PagePropertiesKey } from '@/injection/keys.ts';
    import Auth from '@/classes/Auth.ts';
    import { PageProperties } from '@/types/page-properties.type.ts';

    import Error403 from '@/views/errors/403/403.vue';
    import Error404 from '@/views/errors/404/404.vue';

    import MainHeader from '@/layouts/MainLayout/components/MainHeader.vue';
    import MainFooter from '@/layouts/MainLayout/components/MainFooter.vue';
    import MainMobileHeader from '@/layouts/MainLayout/components/MainMobileHeader.vue';
    import AuthHeader from '@/layouts/AuthLayout/components/AuthHeader.vue';

    const $Auth = injectStrict<Auth>(AuthKey);
    const $PageProperties = injectStrict<PageProperties>(PagePropertiesKey);
</script>

<style lang="scss">
    @use './MainLayout.scss' as *;
</style>
